import type { SupportedCountry } from '@archipro-website/localisation';

/**
 * Gets the domain name for a given country code
 * This method is wildly used in the codebase, so be careful when changing it
 * for old-stack, keep getDomain same as archipro2/javascript/common/helpers/links.ts
 *
 * @param countryCode The country code to get the domain for (AU, US, NZ)
 * @param withHttps Whether to include https:// prefix
 * @param pretty Whether to return the domain in a pretty format (ArchiPro.com.au, ArchiProAmerica.com, ArchiPro.co.nz)
 * @returns The domain name for the given country code
 */
export const getDomain = (
    countryCode: SupportedCountry,
    withHttps = false,
    pretty = false,
): string => {
    let defaultDomain = '';
    switch (countryCode) {
        case 'AU':
            defaultDomain = 'archipro.com.au';
            break;
        case 'US':
            defaultDomain = 'archiproamerica.com';
            break;
        default:
            defaultDomain = 'archipro.co.nz';
            break;
    }
    if (pretty) {
        defaultDomain = defaultDomain
            .replace('archiproamerica', 'ArchiProAmerica')
            .replace('archipro.', 'ArchiPro.');
    }
    return withHttps ? 'https://' + defaultDomain : defaultDomain;
};
